import { NoMarginParagraph } from '@/components/shared/components/common.StyledComponents';
import styled from '@emotion/styled';
import { Button, H1, Paragraph, rem } from '@triumph/design-system';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: ${rem(33)} ${rem(23)} 0 ${rem(32)};
`;

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Title = styled(H1)`
    padding: 0;
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
`;

export const ApplicantId = styled(NoMarginParagraph)`
    line-height: ${rem(20)};
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: ${rem(16)};
    align-items: stretch;
`;

export const MenuButtonWrapper = styled.div`
    button {
        height: 100%;

        > div {
            padding: ${rem(7)} ${rem(16)} ${rem(7)} ${rem(8)};
            gap: ${rem(8)};
        }
    }
`;

export const StyledButton = styled(Button)`
    > div {
        padding: ${rem(7)} ${rem(16)} ${rem(7)} ${rem(8)};
        gap: ${rem(8)};
    }
`;

export const SalesForceButton = styled(Button)`
    width: ${rem(128)};
    > div {
        padding: ${rem(7)} ${rem(16)} ${rem(7)} ${rem(0)};
    }
`;

export const StyledImg = styled.img`
    width: ${rem(25)};
    height: ${rem(27)};
`;

export const SalesForceImg = styled.img`
    width: ${rem(42)};
    height: ${rem(28)};
`;

export const ContactInfoWrapper = styled.div`
    margin-top: ${rem(16)};
    display: flex;
    gap: ${rem(24)};
`;

export const BottomSectionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const EmailPhoneWrapper = styled.div`
    display: flex;
    gap: ${rem(4)};
`;

export const ButtonColumnWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(4)};
    align-items: flex-start;
`;

export const TitleColumnWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(4)};
    align-items: flex-start;
`;


export const LastRefreshedText = styled(Paragraph)<{ isError?: boolean }>`
    font-size: ${rem(12)};
    margin: 0;
    white-space: nowrap;
    color: ${({ theme, isError }) => (isError ? '#d32f2f' : theme.colors.greyscale.gray50)};
    display: flex;
    align-items: center;
`;
